import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { downloadBlob } from '../../utils/downloadUtils';
import { Button } from './Button';
import { useToast } from './Toast';
import { cn } from '../../lib/utils';

/**
 * Export Button component.
 *
 * @param {Function} exportFn - API function that returns a blob
 * @param {Object} params - Query parameters for the export
 * @param {string} filename - Default filename for the downloaded file
 * @param {string} className - Optional tailwind classes
 */
const ExportButton = ({ exportFn, params, filename = 'export.xlsx', className = '' }) => {
  const [downloading, setDownloading] = useState(false);
  const toast = useToast();

  const handleDownload = async () => {
    try {
      setDownloading(true);
      const response = await exportFn(params);
      if (!response.ok) {
        throw new Error(`Export failed (${response.status})`);
      }
      await downloadBlob(response, filename);
    } catch (err) {
      console.error('Export failed:', err);
      toast.error('Export failed. Please try again.');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="xs"
      disabled={downloading}
      className={cn('gap-2', className)}
      onClick={handleDownload}
    >
      {downloading ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <Download className="h-4 w-4" />
      )}
      {downloading ? 'Downloading...' : 'Download'}
    </Button>
  );
};

export { ExportButton };
